import { AxiosResponse } from 'axios';

import AbstractSiteApi from '../AbstractSiteApi';

import { AllCountersData } from './Response/LotteryApi';

class LotteryApi extends AbstractSiteApi {
    protected endpoint: string = 'lottery/';

    public getAllCountersData(): Promise<AllCountersData> {
        return this.get('counters-data').then((response: AxiosResponse) => response.data);
    }
}

export default new LotteryApi();
